<ng-container [formGroup]="subcontractorDetailForm">
  <div class="card-body">
    <h2>Subcontractor Details</h2>
    <div class="form-row">
      <div class="form-group col-12">
        <label for="tax_number" class="custom_label">Tax Number </label>
        <input matInput type="text" id="tax_number" formControlName="tax_number" class="form-control" placeholder="Tax Number" name="tax_number">
        <app-validation-error [formGroup]="subcontractorDetailForm"  [controlName]="'tax_number'"></app-validation-error>
      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="fax" class="custom_label">Fax Number</label>
        <input matInput phoneMask type="text" id="fax" formControlName="fax" class="form-control" placeholder="Fax Number" name="fax">
        <app-validation-error [formGroup]="subcontractorDetailForm" [messagePhoneNumber]="'Invalid Fax Number'" [controlName]="'fax'"></app-validation-error>

      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="website" class="custom_label">Website URL</label>
        <div class="input_with_icon">
          <span class="url-prefix">{{urlPrefix}}</span>
          <input type="url" id="website" (blur)="onBlurWebsiteUrl()" formControlName="website" class="form-control" placeholder="Website URL" name="website">
        </div>
        <app-validation-error [formGroup]="subcontractorDetailForm" [controlName]="'website'"></app-validation-error>

      </div>
    </div>

    <app-address formControlName="address" [model]="model?.address" [isRequired]="false" [form]="form"  (callback)="initChildForm('address', $event.value)  "></app-address>
    <mat-accordion>
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Billing Address
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="my-3 d-flex justify-content-md-end">
          <button type="button" class="btn_solid_color p-2" (click)="copyAddressToBillingAddress()">Copy address</button>
        </div>
        <app-address formControlName="billing_address" [form]="form"  (callback)="initChildForm('billing_address' , $event.value)" [populateFormOnChanges]="billingAddressChangesFlag" [isRequired]="false"  [model]="billing_address"></app-address>

      </mat-expansion-panel>
      @if (subcontractorDetailForm.get('billing_address')?.invalid && subcontractorDetailForm.get('billing_address')?.touched) {
        <div class="error-message">
          <small style="color: red">Billing Address is Required</small>
        </div>
      }
      <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Shipping Address
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="my-3 d-flex justify-content-md-end">
          <button type="button" class="btn_solid_color p-2" (click)="copyAddressToShippingAddress()">Copy address</button>
        </div>
        <app-address formControlName="shipping_address" (callback)="initChildForm('shipping_address' , $event.value)" [populateFormOnChanges]="shippingAddressChangesFlag" [model]="shipping_address" [isRequired]="false"></app-address>
      </mat-expansion-panel>
    </mat-accordion>
    <!--    Billing Address-->
    <!--    <app-address formControlName="billing_address" [model]="model?.billing_address" [isRequired]="false"></app-address>-->
    <!--    Shipping Address-->
    <!--    <app-address formControlName="shipping_address" [model]="model?.shipping_address" [isRequired]="false"></app-address>-->


    <div class="form-row">
      <div class="form-group col-12">
        <label for="misc_notes" class="custom_label">Misc Notes</label>
        <textarea id="misc_notes" class="form-control" formControlName="misc_notes" placeholder="Misc Notes" name="misc_notes"></textarea>
        <app-validation-error [formGroup]="subcontractorDetailForm" [controlName]="'misc_notes'"></app-validation-error>

      </div>
    </div>

    <div class="form-row">
      <div class="form-group col-12">
        <label for="specific_notes" class="custom_label">Notes</label>
        <textarea id="specific_notes" class="form-control" formControlName="specific_notes" placeholder="Specific Notes" name="specific_notes"></textarea>
        <app-validation-error [formGroup]="subcontractorDetailForm" [controlName]="'specific_notes'"></app-validation-error>
      </div>
    </div>
    <mat-slide-toggle formControlName="has_vehicle">Has Vehicle?</mat-slide-toggle>
    <mat-slide-toggle formControlName="can_work_in_state">Can Work in State?</mat-slide-toggle>
    <mat-slide-toggle formControlName="can_work_out_state">Can Work Out State?</mat-slide-toggle>

    @if (subcontractorDetailForm?.value?.can_work_out_state) {
      <div class="form-row">
        <div class="form-group col-12">
          <label for="states" class="custom_label">States</label>
          <ng-select
            id="states"
            [items]="states"
            placeholder="Select States"
            [closeOnSelect]="true"
            [multiple]="true"
            formControlName="states"
            bindLabel="{{coreService.ngSelectBindLabel}}"
            >
          </ng-select>
          <app-validation-error [formGroup]="subcontractorDetailForm" [controlName]="'states'"></app-validation-error>
        </div>
      </div>
    }

  </div>
</ng-container>
